"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var core_1 = require("@material-ui/core");
var Section_1 = __importDefault(require("../../app/components/Section"));
var AppMargins_1 = require("../../app/components/AppMargins");
var RotatingLinksGraphic_1 = __importDefault(require("./RotatingLinksGraphic"));
var useStyles = core_1.makeStyles(function (theme) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    return core_1.createStyles({
        pageHeightContainer: (_a = {
                width: '100%',
                maxWidth: 1440,
                margin: 'auto',
                display: 'flex',
                flexDirection: 'column'
            },
            _a[theme.breakpoints.up('md')] = {
                minHeight: "calc(100vh - " + (theme.spacing(4) + 108) + "px)",
            },
            _a[theme.breakpoints.up('lg')] = {
                minHeight: "calc(100vh - " + (theme.spacing(6) + 108) + "px)",
            },
            _a[theme.breakpoints.down('sm')] = {
                marginTop: theme.spacing(3),
            },
            _a),
        container: (_b = {
                display: 'flex',
                flexDirection: 'column'
            },
            _b[theme.breakpoints.up('lg')] = {
                flexDirection: 'row',
            },
            _b),
        titleTextContainer: (_c = {
                display: 'flex',
                flexDirection: 'column',
                maxWidth: '485px',
                marginBottom: theme.spacing(2),
                fontWeight: 'bold',
                fontSize: '60px'
            },
            _c[theme.breakpoints.down('sm')] = {
                alignItems: 'center',
                margin: '0 auto',
                textAlign: 'center',
            },
            _c['@media screen\\0'] = {
                display: 'inline',
            },
            _c),
        titleText: (_d = {
                fontWeight: 500
            },
            _d[theme.breakpoints.down('sm')] = {
                fontSize: '30px',
            },
            _d),
        subtitleText: (_e = {
                marginTop: theme.spacing(2),
                maxWidth: '404px',
                fontSize: '30px'
            },
            _e[theme.breakpoints.down('sm')] = {
                fontSize: '14px',
            },
            _e),
        rotatingLinksGraphic: (_f = {
                marginTop: theme.spacing(4)
            },
            _f[theme.breakpoints.up('lg')] = {
                marginTop: theme.spacing(0),
            },
            _f[theme.breakpoints.down('lg')] = {
                margin: 'auto',
                marginTop: theme.spacing(4),
            },
            _f),
        fillColor: (_g = {
                display: 'flex',
                flexDirection: 'column',
                flexGrow: 1,
                backgroundColor: theme.palette.primary.dark,
                maxHeight: '30vw',
                minHeight: '150px'
            },
            _g[theme.breakpoints.up('sm')] = {
                minHeight: '200px',
            },
            _g),
        ctaContainer: (_h = {},
            _h[theme.breakpoints.down('sm')] = {
                textAlign: 'center',
                marginTop: theme.spacing(8),
            },
            _h),
        ctaButton: (_j = {
                height: '52px',
                width: '30%',
                fontSize: '16px',
                // Creates the half in colour-fill, half outside it effect.
                marginTop: 'calc(-52px / 2)',
                backgroundColor: theme.palette.primary.main,
                color: '#FFF',
                '&:hover': {
                    backgroundColor: theme.palette.primary.dark,
                }
            },
            _j[theme.breakpoints.down('sm')] = {
                width: '50%',
                fontSize: '14px',
            },
            _j),
        signInTextContainer: (_k = {
                display: 'flex',
                flexGrow: 1,
                alignItems: 'center',
                justifyContent: 'center'
            },
            _k[theme.breakpoints.up('md')] = {
                justifyContent: 'flex-start',
            },
            _k[theme.breakpoints.up('lg')] = {
                marginTop: theme.spacing(4),
                alignItems: 'flex-start',
            },
            _k),
        signInText: {
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(2),
            color: theme.palette.secondary.light,
        },
        signInLink: {
            color: 'inherit',
            textDecoration: 'underline',
            '&:hover': {
                color: theme.palette.common.white,
            },
        },
    });
});
var LandingGraphicSliver = function () {
    var t = react_i18next_1.useTranslation().t;
    var classes = useStyles();
    var theme = core_1.useTheme();
    var isMediumWidth = core_1.useMediaQuery(theme.breakpoints.up('md'));
    var isDesktopWidth = core_1.useMediaQuery(theme.breakpoints.up('lg'));
    var useTopPaddingMultipler = function () {
        if (isMediumWidth) {
            return 1;
        }
        if (isDesktopWidth) {
            return 1.75;
        }
        return 0.5;
    };
    return (react_1.default.createElement("div", { className: classes.pageHeightContainer },
        react_1.default.createElement(Section_1.default, { backgroundType: "transparent", topMultiplier: useTopPaddingMultipler(), bottomMultiplier: 0, verticalMultiplier: isDesktopWidth ? 1 : 0 },
            react_1.default.createElement("div", { className: classes.container },
                react_1.default.createElement(core_1.Grid, { container: true, direction: "row", justifyContent: "center", alignItems: "center" },
                    react_1.default.createElement(core_1.Grid, { item: true, md: 6, sm: 12 },
                        react_1.default.createElement("div", { className: classes.titleTextContainer },
                            t('general.appCatchphrase.noStyle1').startsWith('PoT') ? (react_1.default.createElement(core_1.Typography, { variant: "h1", color: "textPrimary", gutterBottom: true, className: classes.titleText, component: "span" },
                                react_1.default.createElement("span", { style: { color: '#FFC700' } }, t('general.appCatchphrase.noStyle2')),
                                t('general.appCatchphrase.noStyle1'))) : (react_1.default.createElement(core_1.Typography, { variant: "h1", color: "textPrimary", gutterBottom: true, className: classes.titleText, component: "span" },
                                t('general.appCatchphrase.noStyle1'),
                                react_1.default.createElement("span", { style: { color: '#FFC700' } }, t('general.appCatchphrase.noStyle2')))),
                            react_1.default.createElement(core_1.Typography, { className: classes.subtitleText, variant: "subtitle1", color: "textPrimary" },
                                react_1.default.createElement(react_i18next_1.Trans, null, t('general.appDescription.subtitle'))))),
                    react_1.default.createElement(core_1.Grid, { item: true, md: 6, sm: 12, style: { width: '100%' } },
                        react_1.default.createElement(AppMargins_1.IgnoreAppRightMargins, { className: classes.rotatingLinksGraphic },
                            react_1.default.createElement(RotatingLinksGraphic_1.default, null)))))),
        react_1.default.createElement(AppMargins_1.ApplyAppMargins, null,
            react_1.default.createElement("div", { className: classes.ctaContainer },
                react_1.default.createElement(core_1.Button, { className: classes.ctaButton, variant: "contained", href: "/#/login" }, t('button.shorten'))))));
};
exports.default = LandingGraphicSliver;
